/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(4);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(5);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _select = __webpack_require__(6);

	var _select2 = _interopRequireDefault(_select);

	var _userMenu = __webpack_require__(7);

	var _userMenu2 = _interopRequireDefault(_userMenu);

	var _jumpToTop = __webpack_require__(8);

	var _jumpToTop2 = _interopRequireDefault(_jumpToTop);

	var _emptyParagraphs = __webpack_require__(9);

	var _emptyParagraphs2 = _interopRequireDefault(_emptyParagraphs);

	var _accordions = __webpack_require__(10);

	var _accordions2 = _interopRequireDefault(_accordions);

	var _tableImgReplace = __webpack_require__(11);

	var _tableImgReplace2 = _interopRequireDefault(_tableImgReplace);

	var _ajaxComplete = __webpack_require__(12);

	var _ajaxComplete2 = _interopRequireDefault(_ajaxComplete);

	var _detectIE = __webpack_require__(13);

	var _detectIE2 = _interopRequireDefault(_detectIE);

	var _tabsNavigation = __webpack_require__(14);

	var _tabsNavigation2 = _interopRequireDefault(_tabsNavigation);

	var _advancedSearchTrigger = __webpack_require__(15);

	var _advancedSearchTrigger2 = _interopRequireDefault(_advancedSearchTrigger);

	var _calendar = __webpack_require__(16);

	var _calendar2 = _interopRequireDefault(_calendar);

	var _statusMessage = __webpack_require__(17);

	var _statusMessage2 = _interopRequireDefault(_statusMessage);

	var _mobileViewTabs = __webpack_require__(18);

	var _mobileViewTabs2 = _interopRequireDefault(_mobileViewTabs);

	var _iphoneInputFocus = __webpack_require__(19);

	var _iphoneInputFocus2 = _interopRequireDefault(_iphoneInputFocus);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Select 2
		_select2.default.init();

		// User Menu
		_userMenu2.default.init();

		// Jump To Top
		_jumpToTop2.default.init();

		// Empty parahraphs
		_emptyParagraphs2.default.init();

		// Update Accordions
		_accordions2.default.init();

		// Ajax Complete
		_ajaxComplete2.default.init();

		// IE Detector
		_detectIE2.default.init();

		// Tabs secondary navigation
		_tabsNavigation2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Advanced Search
		_advancedSearchTrigger2.default.init();

		// Calendar
		_calendar2.default.init();

		// Status Message
		_statusMessage2.default.init();

		// Mobile view tabs
		_mobileViewTabs2.default.init();

		// Replace png images in table
		_tableImgReplace2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		// Iphone Input Focus
		_iphoneInputFocus2.default.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		$domMenuCountChildren: $('.menu-item--expanded > .menu'),
		$domUserLoginForm: $('#block-userlogin'),
		$domMenuParent: $('.js-main-nav').find('nav > .menu'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$('.js-drupal-fullcalendar').attr('id', 'calendar');
			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-chevron-right" data-open-sub></span>');
				});

				Menu.$domUserLoginForm.detach().appendTo(Menu.$domMenuParent);
			} else {

				Menu.$domMenuCountChildren.each(function (i, el) {
					if ($(el).children().length > 4) {
						$(el).addClass('scroll');
					}
				});

				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).children('a').append('<span class="sub-icon font-chevron-right"></span>');
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: false,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',
		$selectValidation: $('select.required'),
		$inputCreateAccount: $('input[value="Create account"]'),
		$inputVerificationCode: $('input#edit-verification-code'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}

			if (FormValidate.$inputVerificationCode.hasClass('error')) {
				$('.form-item-verification-code').append('<span class="error">Verification code is required.</span>');
			} else {
				$('.form-item-verification-code').find('span.error').remove();
			}

			// $('body.page-user-register').on("select2:select", function(e) {
			//
			// 	FormValidate.$selectValidation.each((i, el) => {
			// 		if($(el).siblings('.select2').find('.select2-selection__rendered').attr('title') == '- Select a value -') {
			// 			FormValidate.$inputCreateAccount.attr('type', 'button');
			// 		}
			// 		else {
			// 			FormValidate.$inputCreateAccount.attr('type', 'submit');
			// 		}
			// 	});
			// });

			FormValidate.$inputCreateAccount.on('click', function (e) {

				FormValidate.$selectValidation.each(function (i, el) {

					if ($(el).siblings('.select2').find('.select2-selection__rendered').attr('title') == '- Select a value -') {
						$(el).siblings('.select2').parent('.js-form-item').append('<span class="error">This field is required.</span>');
						$(el).siblings('.select2').parent('.js-form-item').addClass('border-error');
						// FormValidate.$inputCreateAccount.attr('type', 'button');

						$('html, body').animate({
							scrollTop: $('.select2-selection__rendered[title="- Select a value -"]').offset().top - 270
						}, 100);
					} else {
						$(el).siblings('.select2').parent('.js-form-item').find('span.error').remove();
						$(el).siblings('.select2').parent('.js-form-item').removeClass('border-error');
					}
				});
			});
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),
		$domCountrySelect: $('select#edit-entity-main-field-company-country'),
		$domCountrySelect2: $('select#edit-field-company-country'),
		$domCountrySelect3: $('select#edit-main-profiles-0-entity-field-company-country'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: -1,
				width: '100%'
			});

			Select2.$domCountrySelect.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: 1,
				width: '100%'
			});

			Select2.$domCountrySelect2.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: 1,
				width: '100%'
			});

			Select2.$domCountrySelect3.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: 1,
				width: '100%'
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var UserMenu = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $userMenuTrigger: $('.btn-user'),
	  $userMenuBlock: $('#block-usermenublock'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var body = _global2.default.$domBody;
	    body.addClass('visible');
	    $('html').addClass('visible');

	    body.on('click', function (e) {
	      if ($(e.target).closest(UserMenu.$userMenuBlock).length == 0) {
	        UserMenu.$userMenuBlock.removeClass('collapse');
	      }
	    });

	    UserMenu.$userMenuTrigger.on('click', function (e) {
	      var self = $(e.currentTarget);
	      self.closest('#block-usermenublock').toggleClass('collapse');
	    });
	  }
	};

	exports.default = UserMenu;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var JumpToTop = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $jumpToTop: $('.back-to-top-link'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var offsetView = $('body').offset().top;

	    JumpToTop.$jumpToTop.on('click', function (e) {
	      e.preventDefault();
	      $([document.documentElement, document.body]).animate({
	        scrollTop: offsetView
	      }, 500);
	    });
	  }
	};

	exports.default = JumpToTop;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var EmptyParagraphs = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domParagraphs: $('p'),
	  $domDivs: $('div'),
	  $domHeading2: $('h2'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual

	    EmptyParagraphs.$domParagraphs.filter(function () {
	      var html = $(this).html();
	      $(this).html($(this).html().replace(/&nbsp;/gi, ''));
	      if (html == '' || html == '&nbsp;') return true;
	    }).remove();

	    EmptyParagraphs.$domHeading2.filter(function () {
	      var html = $(this).html();
	      $(this).html($(this).html().replace(/&nbsp;/gi, ''));
	      if (html == '' || html == '&nbsp;') return true;
	    }).remove();

	    EmptyParagraphs.$domDivs.filter(function () {
	      var html = $(this).html();
	      if (html == '' || html == '&nbsp;') return true;
	    }).remove();
	  }
	};

	exports.default = EmptyParagraphs;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Accordions = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $accordionTrigger: $('.view-updates').find('.views-row').find('.title-changed'),
	  $accordionItems: $('.view-updates').find('.views-row'),

	  $faqAccordionItems: $('.c-faq-accordion'),
	  $faqAccordionTrigger: $('.c-faq-accordion').find('.c-faq-question'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    Accordions.$accordionTrigger.on('click', function (e) {
	      var self = $(e.currentTarget);

	      if (self.parent().hasClass('active')) {
	        self.parent().removeClass('active');
	        self.removeClass('active-item');
	      } else {
	        Accordions.$accordionItems.removeClass('active');
	        Accordions.$accordionItems.find('.title-changed').removeClass('active-item');

	        self.parent().addClass('active');
	        self.addClass('active-item');

	        if (_global2.default.varsWindowWidth > 991) {
	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 270
	            }, 400);
	          }, 350);
	        } else {
	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 170
	            }, 400);
	          }, 350);
	        }
	      }
	    });

	    Accordions.$faqAccordionTrigger.on('click', function (e) {
	      var self = $(e.currentTarget);

	      if (self.parent().hasClass('active')) {
	        self.parent().removeClass('active');
	      } else {
	        Accordions.$faqAccordionItems.removeClass('active');

	        self.parent().addClass('active');

	        if (_global2.default.varsWindowWidth > 991) {
	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 270
	            }, 400);
	          }, 350);
	        } else {
	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 160
	            }, 400);
	          }, 350);
	        }
	      }
	    });
	  }
	};

	exports.default = Accordions;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var TableImgReplace = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $table: $('table'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    if (!$('body').hasClass('page-node-book')) {

	      TableImgReplace.$table.find('img').each(function () {

	        if (this.src.length > 0) {
	          var img_src = $(this).attr('src');

	          if (img_src.indexOf('.png')) {
	            var new_src = img_src.replace('.png', '.svg');
	            $(this).attr('src', new_src);
	          }
	        }
	      });
	    }
	  }
	};

	exports.default = TableImgReplace;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _jsFormValidate = __webpack_require__(5);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line

	var AjaxComplete = {

		init: function init() {

			$(document).ajaxComplete(function () {

				_jsFormValidate2.default.init();
			});
		}
	};

	exports.default = AjaxComplete;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var DetectIE = {

	  init: function init() {

	    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

	    if (isIE11) {
	      $('body').addClass('ie11');
	    }
	  }
	};

	exports.default = DetectIE;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var TabsNavigation = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    $('.quicktabs-tabs').addClass('loaded');

	    $(document).ready(function () {
	      if (_global2.default.varsWindowWidth > 991) {

	        var liNumber = $('.quicktabs-tabs li');
	        //check if there are more than 5 elements
	        if (liNumber.length > 3) {
	          liNumber.parent().addClass('tab-slider');
	        }

	        $('.tab-slider').slick({
	          infinite: true,
	          slidesToShow: 3,
	          slidesToScroll: 1,
	          speed: 1000,
	          arrows: true,
	          autoplay: false,
	          dots: false,
	          nextArrow: '<span class="next-arrow font-chevron-right"></span>',
	          prevArrow: '<span class="prev-arrow font-chevron-right"></span>'
	        });

	        $('.quicktabs-tabs').addClass('loaded');
	      }
	    });
	  }
	};

	exports.default = TabsNavigation;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var AdvancedSearch = {

	  $advancedSearchTrigger: $('legend.search-legend'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    AdvancedSearch.$advancedSearchTrigger.on('click', function (e) {
	      var self = $(e.currentTarget);

	      self.toggleClass('active-item');
	      self.siblings('.fieldset-wrapper').toggleClass('active-item');

	      if (_global2.default.varsWindowWidth > 991) {
	        setTimeout(function () {
	          $('html, body').animate({
	            scrollTop: $(self).offset().top - 270
	          }, 400);
	        }, 350);
	      } else {
	        setTimeout(function () {
	          $('html, body').animate({
	            scrollTop: $(self).offset().top - 170
	          }, 400);
	        }, 350);
	      }
	    });
	  }
	};

	exports.default = AdvancedSearch;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var $ = jQuery.noConflict();

	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Calendar = {

	  $calendar: $('.js-drupal-fullcalendar'),
	  $zero: $('.fc-basicDay-view').find('.fc-content-skeleton').find('td'),
	  $archiveMonths: $('.archive-main-wrapper'),
	  $archiveLists: $('.archive-main-wrapper').find('ul'),
	  $archiveEventListMobile: $('.archive-main-wrapper').children('div'),

	  init: function init() {

	    var zeroState = $('.fc-basicDay-view').find('.fc-content-skeleton').find('tbody').find('tr');
	    var calendarTitle = $('.js-drupal-fullcalendar').find('.fc-left').find('h2');

	    if (Calendar.$calendar.length) {
	      var _Calendar$$calendar$f;

	      Calendar.$calendar.fullCalendar('destroy');

	      Calendar.$calendar.fullCalendar((_Calendar$$calendar$f = {

	        header: {
	          left: 'title',
	          right: 'prev,next, month'
	        },
	        firstDay: 1,
	        defaultDate: drupalSettings.defaultDate,
	        locale: drupalSettings.defaultLang,
	        navLinks: drupalSettings.navLinks == 0 ? false : true,
	        editable: true,
	        eventLimit: false,
	        events: drupalSettings.fullCalendarView,
	        eventOverlap: false,
	        timeFormat: 'H:mm',
	        contentHeight: 'auto'
	      }, _defineProperty(_Calendar$$calendar$f, 'contentHeight', function contentHeight() {
	        // if (Global.varsWindowWidth < 991) {
	        //   return 500;
	        // }
	      }), _defineProperty(_Calendar$$calendar$f, 'eventAfterAllRender', function eventAfterAllRender() {
	        $('.js-drupal-fullcalendar').addClass('loaded');

	        if ($('.fc-basicDay-view').find('.fc-content-skeleton').height() < 20) {
	          $('td:empty:first').each(function (i, item) {
	            $(this).addClass('empty-cell').append('<p class="zero-state">There are no events for this day</p>');
	          });
	        }

	        $('.fc-month-button').html('Month view');

	        if (window.innerWidth < 991) {
	          Calendar.$calendar.css('height', '500px');
	        }

	        Calendar.$calendar.find('.fc-left').find('h2').each(function () {
	          var elText,
	              openSpan = '<span class="month">',
	              closeSpan = '</span>';
	          elText = $(this).text().split(" ");
	          elText.unshift(openSpan);
	          elText.splice(2, 0, closeSpan);
	          elText = elText.join(" ");
	          $(this).html(elText);
	        });
	      }), _defineProperty(_Calendar$$calendar$f, 'eventRender', function eventRender(event, element) {
	        var dataToFind = moment(event.start).format('YYYY-MM-DD');
	        $("td[data-date='" + dataToFind + "']").addClass('activeDay');
	      }), _Calendar$$calendar$f));
	    }

	    Calendar.$archiveMonths.find('.month').each(function () {
	      var monthContent = $(this).children('a').attr('class');
	      var listContent = Calendar.$archiveLists.find('a').text();

	      if (listContent.indexOf(monthContent) != -1) {
	        $(this).addClass('has-events');
	      }
	    });

	    if (_global2.default.varsWindowWidth < 576) {
	      Calendar.$archiveEventListMobile.children('.year').on('click', function (e) {
	        var self = $(e.currentTarget);
	        if (self.siblings('.month').is(':hidden')) {
	          self.siblings('.month').slideDown();
	          self.parent().addClass('menu-visible');
	          self.parent().siblings().removeClass('menu-visible');
	          self.parent().siblings().children('.month').slideUp();
	        } else {
	          self.siblings('.month').slideUp();
	          self.parent().removeClass('menu-visible');
	        }
	      });
	    }
	  }
	};

	exports.default = Calendar;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var StatusMessage = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $statusMessage: $('body').find("[aria-label='Status message']"),
	  $errorMessage: $('body').find("[aria-label='Error message']"),
	  $warningMessage: $('body').find("[aria-label='Warning message']"),
	  $editNotification: $('#edit-notification'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    setTimeout(function () {
	      if (StatusMessage.$statusMessage.length > 0) {
	        StatusMessage.$statusMessage.addClass('remove');
	      }
	      if (StatusMessage.$errorMessage.length > 0) {
	        StatusMessage.$errorMessage.addClass('remove');
	      }
	      if (StatusMessage.$warningMessage.length > 0) {
	        StatusMessage.$warningMessage.addClass('remove');
	      }
	      if (StatusMessage.$editNotification.length > 0) {
	        StatusMessage.$editNotification.addClass('remove');
	      }
	    }, 6000);
	  }
	};

	exports.default = StatusMessage;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var MobileViewTabs = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $adminTabs: $('#block-ridp-local-tasks').find('ul'),
	  $quickTabs: $('.quicktabs-tabs'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    if (!_global2.default.$domBody.hasClass("page-search")) {

	      if (_global2.default.varsWindowWidth < 992) {
	        MobileViewTabs.$adminTabs.children('li:first-of-type').each(function (i, el) {
	          $(el).append('<span class="sub-icon font-chevron-right" data-open-sub></span>');
	        });

	        MobileViewTabs.$adminTabs.on('click', '[data-open-sub]', function (e) {
	          e.preventDefault();
	          MobileViewTabs.$adminTabs.toggleClass('dropdown-toggle');
	        });

	        MobileViewTabs.$quickTabs.children('li:first-of-type').each(function (i, el) {
	          $(el).append('<span class="sub-icon font-chevron-right" data-open-sub></span>');
	        });

	        MobileViewTabs.$quickTabs.on('click', '[data-open-sub]', function (e) {
	          e.preventDefault();
	          MobileViewTabs.$quickTabs.toggleClass('dropdown-toggle');
	        });
	      }
	    }
	  }
	};

	exports.default = MobileViewTabs;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var IphoneFix = {
	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // drupal fix for multilingual

	    $("input, textarea").on({ 'touchstart': function touchstart() {
	        zoomDisable();
	      } });

	    $("input, textarea").on({ 'touchend': function touchend() {
	        setTimeout(zoomEnable, 500);
	      } });

	    function zoomDisable() {
	      $('head meta[name=viewport]').remove();
	      $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />');
	    }

	    function zoomEnable() {
	      $('head meta[name=viewport]').remove();
	      $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=1" />');
	    }
	  }
	};

	exports.default = IphoneFix;

/***/ })
/******/ ]);